import React from "react";
import { Col, Container, Row } from "react-bootstrap";
//import AboutAndSustainabilityContentForm from "./AboutAndSustainabilityContentForm";
import FaqPageContentForm from "./FaqPageContentForm";
//import { useGetAboutAndSustainabilityContentDetailsQuery } from "../../../../store/services/AboutAndSustainabilityContentService";
import { useGetFaqPageContentDetailsQuery } from "../../../../store/services/FaqPageContentService";

function FaqpageContent() {
  const { data: pageDetails, error, isLoading } = useGetFaqPageContentDetailsQuery();

  console.log("Faqdetails =======>", pageDetails?.data);

  return (
    <section className="setting position-relative py-3">
      <Container>
        <Row className="justify-content-center">
          <Col lg="12">
            <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
              FAQ Page Content
            </h4>
          </Col>

          {isLoading && (
            <div className="text-center">
              <div className="spinner-border text-dark">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {!isLoading && (
            <FaqPageContentForm data={pageDetails?.data} />
          )}
        </Row>
      </Container>
    </section>
  );
}

export default FaqpageContent;
